import types from '../types';

const feesAndLimits = (state = { loading: true, data: null }, { type, payload }) => {
  switch (type) {
    case types.GET_FEES_AND_LIMITS_START:
      return { ...state, loading: true };

    case types.GET_FEES_AND_LIMITS_FAILURE:
      return { ...state, loading: false };

    case types.GET_FEES_AND_LIMITS_SUCCESS:
      return { ...state, data: payload, loading: false };

    default:
      return state;
  }
};

export default feesAndLimits;
